import * as React from "react";
import {
    PlasmicProjectCard,
    DefaultProjectCardProps
} from "./plasmic/main/PlasmicProjectCard";
import {useRef, useState} from "react";
import {TextInputRefValue} from "@plasmicapp/react-web";
import {Project} from "../models/fauna/dbSchema";
import {useLinkClickHandler} from "react-router-dom";


interface ProjectCardProps extends DefaultProjectCardProps {
    className?: string;
    entry: Project
    onChange: (name: string) => void;
    onDelete: () => void;
}

type projectCardStatus = 'editingMenu' | 'editingName' | 'uploading' | undefined;

function ProjectCard({entry, onChange, onDelete, ...rest}: ProjectCardProps) {
    const textbox = useRef<TextInputRefValue>(null);
    const [cardState, setCardState] = useState<projectCardStatus>(undefined);

    const finishNameEditing = () => {
        if (textbox.current?.getInput()?.value !== entry.name) {
            onChange(textbox.current?.getInput()?.value || '');
        }
        setCardState(undefined);
    }



    return <PlasmicProjectCard
            {...rest}
            state={cardState}
            projectLink={{
                onClick: useLinkClickHandler(`/project/${entry.id}`)
            }}
            settings={{
                onClick: (e) => {
                    e.stopPropagation();
                    setCardState('editingMenu');
                }
            }}
            renameOption={{
                onClick: () => setCardState('editingName')
            }}
            deleteOption={{
                onClick: () => {
                    onDelete();
                    setCardState(undefined);
                }
            }}
            close={{
                onClick: () => finishNameEditing()
            }}
            textbox={{
                ref: textbox,
                autoFocus: true,
                onBlur: () => {
                    finishNameEditing();
                },
                defaultValue: entry.name,
                onKeyDown: (event: any) => {
                    if (event.key === 'Enter') {
                        finishNameEditing();
                    }
                }
            }}
        >
            {entry.name}
        </PlasmicProjectCard>;
}

export default ProjectCard;
